import React, { useState } from 'react'

const Tooltip = ({ text, children, position = 'top', variant = 'purple' }) => {
  const [isVisible, setIsVisible] = useState(false)

  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-3',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-3',
    left: 'right-full top-1/2 -translate-y-1/2 mr-3',
    right: 'left-full top-1/2 -translate-y-1/2 ml-3',
  }

  const arrowClasses = {
    top: 'top-full left-1/2 -translate-x-1/2',
    bottom: 'bottom-full left-1/2 -translate-x-1/2 rotate-180',
    left: 'left-full top-1/2 -translate-y-1/2 -rotate-90',
    right: 'right-full top-1/2 -translate-y-1/2 rotate-90',
  }

  const variants = {
    purple: {
      bg: 'linear-gradient(135deg, #7C007C 0%, #911C9C 100%)',
      shadow: '0 10px 25px -5px rgba(124, 0, 124, 0.4), 0 8px 10px -6px rgba(124, 0, 124, 0.1)',
      border: '#911C9C',
      arrowColor: '#7C007C',
    },
    royal: {
      bg: 'linear-gradient(135deg, #305CDE 0%, #4A73E8 100%)',
      shadow: '0 10px 25px -5px rgba(48, 92, 222, 0.4), 0 8px 10px -6px rgba(48, 92, 222, 0.1)',
      border: '#305CDE',
      arrowColor: '#305CDE',
    },
    lilac: {
      bg: 'linear-gradient(135deg, #A47DAB 0%, #B494C7 100%)',
      shadow: '0 10px 25px -5px rgba(164, 125, 171, 0.4), 0 8px 10px -6px rgba(164, 125, 171, 0.1)',
      border: '#A47DAB',
      arrowColor: '#A47DAB',
    },
  }

  const currentVariant = variants[variant]

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && (
        <div
          className={`absolute ${positionClasses[position]} text-white text-sm font-medium px-4 py-2.5 rounded-xl whitespace-nowrap z-50 transform transition-all duration-300 ease-out ${
            isVisible ? 'opacity-100 scale-100 translate-y-0' : 'opacity-0 scale-95 translate-y-1'
          }`}
          style={{
            background: currentVariant.bg,
            boxShadow: currentVariant.shadow,
            backdropFilter: 'blur(10px)',
            border: `1px solid ${currentVariant.border}20`,
          }}
        >
          {text}
          {/* Arrow */}
          <div
            className={`absolute w-0 h-0 ${arrowClasses[position]}`}
            style={{
              borderLeft: '6px solid transparent',
              borderRight: '6px solid transparent',
              borderTop: `6px solid ${currentVariant.arrowColor}`,
              filter: 'drop-shadow(0 -1px 1px rgba(0,0,0,0.1))',
            }}
          />
        </div>
      )}
    </div>
  )
}

export default Tooltip
